import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckBox = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="none" stroke="currentColor" />
  </SvgIcon>
);
